import { render } from "./UserManagement.vue?vue&type=template&id=37795f58"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"

import "./UserManagement.vue?vue&type=style&index=0&id=37795f58&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__